import moment from 'moment'
import * as yup from 'yup'

export interface FedExShipmentDto {
  fedExShipmentGuid?: string
  trackingNumber?: string
  /** @deprecated Use fedExShipmentGuid with /api/fedex/labels instead. */
  labelUrl?: string
  packageType: string
  date: string
  time: string
  deliveryType: string
  weightLbs: number
  recipientContactPersonName?: string
  recipientContactPhoneNumber: string
  recipientContactCompanyName?: string
  recipientAddressStreetLine1: string
  recipientAddressStreetLine2?: string
  recipientAddressCity: string
  recipientAddressStateOrProvinceCode: string
  recipientAddressPostalCode: string
  shipDateTime?: string
  deliveryDateTime?: string
}

export const fedExShipmentInit: FedExShipmentDto = {
  packageType: 'FEDEX_ENVELOPE',
  date: moment().add(1, 'day').format('yyyy-MM-DD'),
  time: '17:00',
  deliveryType: 'STANDARD_OVERNIGHT',
  weightLbs: 1,
  recipientContactPhoneNumber: '',
  recipientAddressStreetLine1: '',
  recipientAddressCity: '',
  recipientAddressStateOrProvinceCode: '',
  recipientAddressPostalCode: ''
}

export const fedExShipmentValidationSchema = yup.object<FedExShipmentDto>({
  packageType: yup.string().required('Package Type is required.'),
  date: yup.date().min(new Date(), 'Ship Date cannot be in the past.').required('Ship Date is required.').typeError('Ship Date is required.'),
  // min 5 = 00:00 max 8 = 00:00:00
  time: yup.string().min(5, 'Ship Time is required.').max(8, 'Ship Time is required.').required('Ship Time is required.'),
  deliveryType: yup.string().required('Delivery Type is required.'),
  weightLbs: yup.number().min(0.01, 'Weight (Lbs.) cannot be less than 0.01 Lbs.').required('Weight (Lbs.) is required.'),
  recipientContactPersonName: yup.string().max(250, 'Ship To Name cannot be more than 250 characters.').required('Ship To Name is required.'),
  recipientContactPhoneNumber: yup
    .string()
    .min(10, 'Ship To Phone cannot be less than 10 characters.')
    .max(15, 'Ship To Phone cannot be more than 15 characters.')
    .required('Ship To Phone is required.'),
  recipientAddressStreetLine1: yup.string().max(250, 'Ship To Address cannot be more than 250 characters.').required('Ship To Address is required.'),
  recipientAddressCity: yup.string().max(250, 'Ship To City cannot be more than 250 characters.').required('Ship To City is required.'),
  recipientAddressStateOrProvinceCode: yup.string().max(2, 'Ship To State cannot be more than 2 characters.').required('Ship To State is required.'),
  recipientAddressPostalCode: yup.string().max(250, 'Ship To Postal Code cannot be more than 250 characters.').required('Ship To Postal Code is required.')
})
